export const environment = {
  production: true,
  version_check_time: 60, // time in s
  api_url: 'https://ems.skuba.eu/api',
  url: 'https://ems.skuba.eu',
  media_url: 'https://ems.skuba.eu/media',
  frontend_url: 'https://ems.skuba.eu',
  hmr: false
};
